import { i18n } from '@/shared/i18n';

/**
 * UI-only cap on how many guidelines a user can select in the chat picker.
 * The backend imposes no equivalent limit — programmatic API callers may pass
 * arbitrary IDs (the guidelines client chunks the request and Sentinel runs
 * sub-agents in bounded-parallel batches). This cap keeps interactive QA runs
 * within a reasonable wall-clock window.
 */
export const MAX_SELECTED_GUIDELINES = 50;

// Resolved per call, never at module scope: a module-scope const would bake in whatever
// language was active at import and could never follow a change.
export const getGuidelinesLimitMessage = (): string =>
  i18n.t('chats:chats.chatGuidelinesSelector.youCanPickUpTo', { max: MAX_SELECTED_GUIDELINES });
